import { createContext, useContext } from "react";

import type { RadioButtonGroupDirection } from "./constants";

export type RadioButtonGroupContextValue = {
  disabled?: boolean;
  negative?: boolean;
  dir?: RadioButtonGroupDirection;
};

export const RadioButtonGroupContext = createContext<RadioButtonGroupContextValue | null>(null);

export const useRadioButtonGroupContext = () => {
  const context = useContext(RadioButtonGroupContext);

  if (!context) {
    throw new Error("RadioButtonGroupItem must be used within a RadioButtonGroup component");
  }
  return context;
};
